const PERSONART = {
  NATUERLICHE_PERSON: {
    KUERZEL: "N",
    BEZEICHNUNG: "Natürliche Person",
  },
  JURISTISCHE_PERSON: {
    KUERZEL: "J",
    BEZEICHNUNG: "Juristische Person",
  },
  WIRTSCHAFTLICHE_PERSON: {
    KUERZEL: "P",
    BEZEICHNUNG: "Wirtschaftlich unselbst. Person Privatpersonen",
  },
}
export default PERSONART;
